import type { JSONContent } from "@tiptap/react";
import {
  emptyDoc,
  parseRichTextDocResult,
  type RichTextDoc,
  type RichTextMark,
  type RichTextNode,
  type RichTextParseError,
} from "../domain/richText";
import type { Result } from "../domain/result";

export const richTextDocToJsonContent = (doc: RichTextDoc): JSONContent =>
  richTextNodeToJsonContent(doc);

export const jsonContentToRichTextDocResult = (
  content: JSONContent,
): Result<RichTextDoc, RichTextParseError> => parseRichTextDocResult(content);

export const jsonContentToRichTextDoc = (content: JSONContent): RichTextDoc => {
  const parsed = jsonContentToRichTextDocResult(content);
  return parsed.ok ? parsed.value : emptyDoc();
};

export const tiptapContentNeedsSync = (
  current: JSONContent,
  next: RichTextDoc,
): boolean => JSON.stringify(current) !== JSON.stringify(richTextDocToJsonContent(next));

const richTextNodeToJsonContent = (node: RichTextDoc | RichTextNode): JSONContent => {
  const attrs = "attrs" in node ? node.attrs : undefined;
  const text = "text" in node ? node.text : undefined;
  const marks = "marks" in node ? node.marks : undefined;

  return {
    type: node.type,
    ...(attrs === undefined ? {} : { attrs }),
    ...(text === undefined ? {} : { text }),
    ...(marks === undefined ? {} : { marks: marks.map(richTextMarkToJsonContent) }),
    ...(node.content === undefined ? {} : { content: node.content.map(richTextNodeToJsonContent) }),
  };
};

const richTextMarkToJsonContent = (mark: RichTextMark): NonNullable<JSONContent["marks"]>[number] => ({
  type: mark.type,
  ...(mark.attrs === undefined ? {} : { attrs: mark.attrs }),
});
